/* import __COLOCATED_TEMPLATE__ from './bias-current.hbs'; */
import Component from '@glimmer/component';

export default class BiasCurrentError extends Component {
  get nonInverting() {
    return this.args.model.chartHandler.data.errorDistribution.errorHeader === 'Non-Inverting Amplifier';
  }
}
